import { AnimatePresence } from 'motion/react'
import { cloneElement } from 'react'
import type { DropdownMenuProps } from './DropdownMenu'
import MenuItem, { type MenuItemProps } from './Item'
import styles from './DropdownMenu.module.css'

interface DropdownMenuItemsProps {
	data: DropdownMenuProps['data']
	onSelect: DropdownMenuProps['onSelect']
	activeId: string | null
	onClose: () => void
}

export default function DropdownMenuItems({
	data,
	onSelect,
	activeId,
	onClose,
}: DropdownMenuItemsProps) {
	return (
		<div role="menu" className={styles.menu}>
			<AnimatePresence mode="popLayout">
				{data.map((item, index) => {
					const props: MenuItemProps = {
						...item.props,
						data: item,
						onClick: (id, data, event) => {
							event.stopPropagation()
							onSelect(id, data, event)
							onClose()
						},
						isActive: item.id === activeId,
						initial: { x: -10, opacity: 0 },
						animate: { x: 0, opacity: 1, transition: { delay: index * 0.04, damping: 20 } },
						exit: { x: 10, opacity: 0 },
					}
					if (item.render) {
						const element = item.render(props)
						return cloneElement(element, { key: element.key ?? item.id })
					}
					return <MenuItem key={item.id} {...props} />
				})}
			</AnimatePresence>
		</div>
	)
}
